import {Modal as ReactModal, ModalHeader, ModalBody, ModalFooter as ReactModalFooter} from 'reactstrap'
import style from './Modal.module.scss'

const getModalWidth = (modalSize: modalSize) : string => {
    let size = ""
    if (modalSize == "sm") {
       size = style.modalSM;
    }
    else if (modalSize == "md") {
        size = style.modalMD;
    }
    else if (modalSize == "xl") {
        size = style.modalXL;
    }
    else {
        size = "modal-fullscreen d-grid";
    }
    return size;
}

 const Modal = (props: modalProps) => {
    const formContainerStyle = props.size !== "full" ? style.formContainer : style.formContainerFull;

    return (
        <ReactModal isOpen={props.isOpen} className={`${style.modal} ${getModalWidth(props.size)}`} toggle={props.closeFilterModal}>
            <ModalHeader toggle={props.closeFilterModal} className={style.header}>
                <span className={style.title}>
                    {props.title}
                </span>
            </ModalHeader>
            <ModalBody style={{padding: 0, overflowY:'visible'}}>
                <div className={`form-container p-3 ${formContainerStyle} ${props.hasOverflow ? style.formContainerOverflow : ''}`}>
                    {props.children}
                </div>
            </ModalBody>
            
        </ReactModal>
    )
}

export default Modal;

interface modalProps {
    isOpen: boolean;
    closeFilterModal: () => void;
    children?: React.ReactNode;
    title: string;
    size: modalSize;
    hasOverflow: boolean;
}

type modalSize = "sm"|"md"|"xl"|"full";

Modal.defaultProps = {
    isOpen: false,
    size: "sm",
    hasOverflow: true
} 